import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClassificationReporterService } from 'src/app/views/apps/news-analyzer/classification-reporter.service';
import { SENTIMENTS } from 'src/app/views/apps/news-analyzer/utils';

export interface DialogData {
    text: string;
    sentiment: string,
    token: string
}

@Component({
    selector: 'app-dialog-rectify-sentiment',
    templateUrl: 'dialog-rectify-sentiment.html',
})
export class DialogRectifySentimentComponent implements OnInit {
    listOfSentiments: { name }[]
    selectedSentiment: any

    constructor(
        public dialogRef: MatDialogRef<DialogRectifySentimentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private classificationReporterService: ClassificationReporterService) { }

    ngOnInit() {
        this.listOfSentiments = SENTIMENTS.filter(s => s !== this.data.sentiment)
            .map(sentiment => ({ name: sentiment }))
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    onRectifyClick(): void {
        console.log(this.selectedSentiment)
        this.classificationReporterService.reportWrongClassification(this.data.text, this.data.sentiment, this.selectedSentiment, 'sentiment', this.data.token)
        this.dialogRef.close();
    }
}
